document.addEventListener('alpine:init', () => {
  const PREDICTIVE_SEARCH_SECTION = "tailwind-predictive-search";

  const createSearchUrl = (searchTerm) => {
    const enTerm = encodeURIComponent(searchTerm);
    const enFilter = encodeURIComponent('resources[type]');
    let url = `${routes.predictive_search_url}?q=${enTerm}&${enFilter}=product,query`;

    if (window.predictiveSearchSettings) {
      const {
        limit,
        type,
        show_collections,
        show_pages,
        show_articles
      } = window.predictiveSearchSettings

      if (show_collections) { // coming from resources[type]=product:
        url += ',collection';
      }
      if (show_pages) {
        url += ',page';
      }
      if (show_articles) {
        url += ',article';
      }

      url += `&${
        encodeURIComponent('resources[limit]')
      }=${limit}`;
      url += `&${
        encodeURIComponent('resources[limit_scope]')
      }=${type}`;
    }
    url += `&section_id=${PREDICTIVE_SEARCH_SECTION}`;

    return url;
  };

  Alpine.store("predictiveSearch", {
    term: "",
    noResultsPrompt: "",
    recentSearches: [],
    cachedResults: {},
    resultsHtml: "",
    init() {
      const previouslySavedRecentSearches = localStorage.getItem("recent-searches");
      if (previouslySavedRecentSearches) {
        this.recentSearches = JSON.parse(previouslySavedRecentSearches);
      }

      const params = window.getQueryParams();
      if (params.q != "") {
        this.term = params.q;
        this.startSearching();
      }

      // if ('virtualKeyboard' in navigator) {
      //   navigator.virtualKeyboard.overlaysContent = true;
      // }
    },
    startSearching() {
      this.noResultsPrompt = "";
      if (!this.term || this.term.trim() === "") {
        this.resultsHtml = "";
        return;
      }

      const queryKey = this.term.replace(" ", "-").toLowerCase();
      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      fetch(createSearchUrl(this.term)).then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          throw error;
        }

        return response.text();
      }).then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector(`#shopify-section-${PREDICTIVE_SEARCH_SECTION}`).innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      }).catch((error) => {
        throw error;
      });
    },
    submitSearch(e) { // submitSearch will have it's `this` keyword based on the form
      e.preventDefault();

      const self = Alpine.store("predictiveSearch");

      if (`${self.term}`.trim() === "") {
        self.resultsHtml = "";
        return;
      }

      self.term = self.term.trim();

      const url = `${window.routes.search_url}?q=${self.term.trim()}`;
      const hasBeenSearchedBefore = self.recentSearches.some(s => s.url == url);
      if (!hasBeenSearchedBefore) {
        self.addRecentSearch(self.term, url);
      }
      
      // Allow for alpine to trim the field first
      setTimeout(() => e.target.submit(), 100);
    },
    shouldShowRecentSearches() {
      return this.resultsHtml == "" && this.recentSearches.length > 0 && !this.term;
    },
    shouldShowAlternativeSearches() {
      return this.resultsHtml == "" && this.term;
    },
    addRecentSearch(term, url) {
      const maxRecentSearches = window.predictiveSearchSettings.recently_searched_save_count;
      localStorage.setItem("recent-searches", JSON.stringify([
        {
          term,
          url
        },
        ...this.recentSearches
      ].slice(0, maxRecentSearches)));
    },
    clearRecentSearches() {
      localStorage.setItem("recent-searches", "[]");
      this.recentSearches = [];
    },
    clearTerm() {
      this.term = "";
      this.startSearching();
    },
    renderSearchResults(html) {
      this.resultsHtml = `${html}`.trim().replace(/\n/g, '');

      if (this.resultsHtml == "") {
        this.noResultsPrompt = `No results found for ${this.term}`;
      }

// for some reason, I can't "hydrate" markup that is set with x-html, so let's do vanilla here for now
      setTimeout(() => {
        const links = document.querySelectorAll('[data-search-result-item-link]');
        for (const link of links) { // use the links, it's hard to use e.target
          link.addEventListener("click", (e) => {
            const term = link.getAttribute("data-search-result-item-link");
            if (term) {
              Alpine.store("predictiveSearch").addRecentSearch(term, link.getAttribute("href"));
            }
          })
        }
      }, 200)
    }
  });

  // Call for this function is removed for now. This is a WIP and selecting results might be a task that needs more attention later
  const listenToKeyPress = () => {
    const searchField = document.querySelector('[name="q"]');
    const container = document.querySelector('[data-search-result-selectable-container]');
    
    let active = null;

    document.addEventListener("keydown", handler);    

    const DOWN = 40;
    const UP = 38;    

    function handler(e) {      
      const selectables = container.querySelectorAll("[data-search-result-selectable]");      
      active && active.classList.remove("bg-gray-100");
      if (e.which == DOWN) {
        searchField.blur();
        active = container.querySelector("[data-search-result-selectable]")
      } else if (e.which == UP) {
        searchField.blur();
        active = active.previousElementSibling || active;
      }
      active && active.classList.add("bg-gray-100");
      
      document.activeElement = active;
    }
  }
});